import React from 'react'
import "./Current_rank.css"
import Common_recharge_page_banner from '../../common_components/common_banner/common_recharge_page_banner/Common_recharge_page_banner'
import Current_rank_cards_section from './current_rank_cards_section/Current_rank_cards_section'

function Current_rank() {
    return (
        <>
            <section className='Current_rank upgraded_menu_sections'>
                <div className="container">

                    <Common_recharge_page_banner title="Current Rank" className="Upgraded_menu_banner" />
                    <div className="row justify-content-center">
                        <div className="col-lg-7 col-md-10">
                            <div className="profile_tabs_and_content">
                                <div className="section_holder">
                                    <Current_rank_cards_section />
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </section>
        </>
    )
}

export default Current_rank